(function () {
  var AVAILABILITY_SORT = 'availability desc';

  function getUnbxdSearchPageConfig() {
    return window.UnbxdSearchPageConfig || {};
  }


  function formatMetaOptionObj(obj) {
    if (!obj || !obj.options || !Array.isArray(obj.options) || !obj.options.length) return '';
    return obj.options
      .filter(function (opt) {
        return opt && opt.name != null && opt.value != null && String(opt.value).trim() !== '';
      })
      .map(function (opt) {
        var count = Number(opt.value);
        var displayCount = isNaN(count) ? String(opt.value).trim() : count;
        return displayCount + ' ' + String(opt.name).trim();
      })
      .join(' | ');
  }

  function getMetaOptionObjLabel(product) {
    var raw = product.meta_option_obj;
    if (!raw) return '';
    if (typeof raw === 'object' && !Array.isArray(raw)) return formatMetaOptionObj(raw);
    var jsonStr = Array.isArray(raw) ? (raw[0] || '') : raw;
    if (!jsonStr || typeof jsonStr !== 'string') return '';
    try { return formatMetaOptionObj(JSON.parse(jsonStr)); } catch (err) { return ''; }
  }

  function buildPreTagHtml(product, metaPre) {
    var parts = [];
    if (metaPre) parts.push(metaPre);
    var optionsLabel = getMetaOptionObjLabel(product);
    if (optionsLabel) parts.push(optionsLabel);
    if (!parts.length) return '';
    return '<span class="pre_tag">' + parts.join('  ') + '</span>';
  }

  function isSearchVariantAvailable(variant) {
    if (!variant) return false;
    var val = variant.v_availableForSale;
    return val === true || val === 'true' || val === 1 || val === '1';
  }

  function getPreferredSearchVariant(product) {
    if (!product.variants || !product.variants.length) return null;
    var available = product.variants.reverse().find(function (v) {
      return isSearchVariantAvailable(v) && v.variantId;
    });
    if (available) return available;
    return product.variants.find(function (v) { return v.variantId; }) || product.variants[0];
  }

  function getSearchProductImages(product, selectedVariant) {
    var firstImg = Array.isArray(product.imageUrl) ? (product.imageUrl[0] || '') : (product.imageUrl || '');
    var secondImg = firstImg;
    var allImages = [];
    if (Array.isArray(product.imageUrl) && product.imageUrl.length > 1) {
      allImages = product.imageUrl.slice();
    } else if (product.images) {
      allImages = Array.isArray(product.images) ? product.images : String(product.images).split(',');
    }
    allImages = allImages.map(function (i) { return (i || '').trim(); }).filter(Boolean);
    for (var i = 0; i < allImages.length; i++) {
      if (allImages[i] !== firstImg) { secondImg = allImages[i]; break; }
    }
    var variantImg = firstImg;
    if (selectedVariant && selectedVariant.v_imageUrl && String(selectedVariant.v_imageUrl).trim()) {
      variantImg = selectedVariant.v_imageUrl;
    }
    if (!variantImg || !String(variantImg).trim()) variantImg = firstImg;
    return { firstImg: firstImg, secondImg: secondImg, variantImg: variantImg };
  }

  function buildSearchPriceHtml(variant, product) {
    var v = variant || { v_price: product.price || 0, v_compareAtPrice: product.v_compareAtPrice || 0 };
    var price = Number(v.v_price) || 0;
    var compare = Number(v.v_compareAtPrice) || 0;
    if (price < compare) {
      return {
        extraClass: 'price--on-sale',
        html: '<div class="price__sale"><span><s class="price-item price-item--regular">$' + compare.toFixed(2) + '</s></span>'
          + '<span class="price-item price-item--sale price-item--last">$' + price.toFixed(2) + '</span></div>'
      };
    }
    return {
      extraClass: '',
      html: '<div class="price__regular"><span class="price-item price-item--regular">$' + price.toFixed(2) + '</span></div>'
    };
  }

  function buildSearchQuickViewHtml(product, selectedVariant) {
    var url = product.productUrl || '';
    if (selectedVariant && selectedVariant.variantId) url += '?variant=' + selectedVariant.variantId;
    var id = product.uniqueId;
    var title = product.title || '';
    var btn = '<modal-opener data-modal="#QuickAdd-' + id + '"><button id="' + id + '-submit" type="submit" name="add"'
      + ' class="quick-add__submit-- button button--full-width--" aria-haspopup="dialog" aria-labelledby="' + id + '-submit"'
      + ' data-product-url="' + url + '"> Quick Buy <div class="loading__spinner hidden"><svg aria-hidden="true"'
      + ' focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg" width="20px" height="20px">'
      + '<circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div></button></modal-opener>';
    var modal = '<quick-add-modal id="QuickAdd-' + id + '" class="quick-add-modal"><div role="dialog" aria-label="' + title + '"'
      + ' aria-modal="true" class="quick-add-modal__content global-settings-popup" tabindex="-1"><button id="ModalClose-' + id + '"'
      + ' type="button" class="quick-add-modal__toggle" aria-label="Close"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true"'
      + ' focusable="false" class="icon icon-close" fill="none" viewBox="0 0 18 17"><path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431'
      + ' 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0'
      + ' 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor"></path></svg></button><div id="QuickAddInfo-' + id + '"'
      + ' class="quick-add-modal__content-info"></div></div></quick-add-modal>';
    return btn + modal;
  }

  function renderSearchProductTemplate(product, idx, swatchUI, productViewType) {
    if (!product) return [''];
    var selectedVariant = getPreferredSearchVariant(product);
    var priceInfo = buildSearchPriceHtml(selectedVariant, product);
    var metaPre = product.meta_pre_tag ? product.meta_pre_tag[0] : '';
    var preTagHtml = buildPreTagHtml(product, metaPre);
    var images = getSearchProductImages(product, selectedVariant);
    var quickViewHtml = buildSearchQuickViewHtml(product, selectedVariant);
    var reviewStar = '<div class="klaviyo-star-rating-widget" data-id="' + product.uniqueId + '" data-product-title="' + (product.title || '') + '"></div>';
    var soldOutBadge = String(product.availability) === 'false'
      ? "<div class='UNX-grid-card__badge'><span class='soldout-badge'>sold out</span></div>" : '';

    var $saleLabel = "";
    if(product.category && product.category.includes("Sale") && String(product.availability) != 'false'){
        const discountPercent = selectedVariant.v_compareAtPrice > selectedVariant.v_price ? Math.round(((selectedVariant.v_compareAtPrice - selectedVariant.v_price) / selectedVariant.v_compareAtPrice) * 100 ) : 0;
        if(discountPercent > 0){
            $saleLabel = `<span class="UNX-grid-card__badge">${discountPercent}% OFF</span>`;
        }
    }

    if (productViewType === 'LIST') {
      var description = '';
      if (product.descriptionHtml) {
        description = String(product.descriptionHtml).replace(/(<([^>]+)>)/ig, '').substring(0, 130) + '...';
      } else if (product.description) {
        description = String(product.description).substring(0, 130) + '...';
      }
      return ['<div id="' + product.uniqueId + '" data-id="' + product.uniqueId + '" data-prank="' + idx + '" data-item="product" class="UNX-product-col list-view">' + soldOutBadge + $saleLabel
        + '<div class="UNX-images-block"><a href="' + product.productUrl + '"><div class="UNX-img-wrapper"><img class="UNX-img-block primary" src="' + images.variantImg + '&width=600">'
        + '<img class="UNX-img-block hover" src="' + images.secondImg + '&width=600"></div></a></div><div class="block__list-view--content" style="flex:1;">'
        + preTagHtml + '<h3>' + (product.title || '') + '</h3>' + reviewStar + '<p>' + description + '</p>'
        + '<div class="UNX-price-row ' + priceInfo.extraClass + '"><div class="UNX-sale-price">' + priceInfo.html + '</div></div>'
        + '<div class="block__list-view--wuick-button" style="margin-top:10px;"><a href="' + product.productUrl + '" class="button">View Product</a>'
        + quickViewHtml + '</div></div></div>'];
    }

    return ['<div id="' + product.uniqueId + '" data-id="' + product.uniqueId + '" data-prank="' + idx + '" data-item="product" class="UNX-product-col UNX-grid-card product-item product-grid">' + soldOutBadge + $saleLabel
      + '<div class="UNX-images-block"><a href="' + product.productUrl + '"><div class="UNX-img-wrapper"><img class="UNX-img-block primary" src="' + images.variantImg + '&width=400">'
      + '<img class="UNX-img-block hover" src="' + images.secondImg + '&width=400"></div></a></div><div class="UNX-product-content">' + preTagHtml
      + '<a href="' + product.productUrl + '"><h3 class="UNX-product-title card__heading h5">' + (product.title || '') + '</h3></a>' + reviewStar
      + '<div class="UNX-price-row ' + priceInfo.extraClass + '"><div class="UNX-sale-price">' + priceInfo.html + '</div></div>'
      + quickViewHtml + '</div></div>'];
  }


  function applyUnbxdSearchPatches(instance) {
    if (window.unbxdPatchUnbxdSearchInput) window.unbxdPatchUnbxdSearchInput(instance);
    if (window.patchUnbxdActiveSearchInput) window.patchUnbxdActiveSearchInput(instance);
    patchUnbxdAvailabilitySort(instance);
    patchUnbxdProductImpressionDedup(instance);
    patchUnbxdSearchProductClickDedup(instance);
    patchUnbxdSortUrlSync(instance);
    syncAvailabilitySortFilter(instance);
  }

  function bootstrapUnbxdSearchPage(instance, searchTerms) {
    if (window.normalizeUnbxdSearchQuery) {
      searchTerms = window.normalizeUnbxdSearchQuery(searchTerms);
    }
    var activeSearchInput = window.getActiveHeaderSearchInput
      ? window.getActiveHeaderSearchInput()
      : document.getElementById('Search-In-Modal');
    if (activeSearchInput && searchTerms) {
      activeSearchInput.value = searchTerms;
      if (window.syncHeaderSearchInputValues) {
        window.syncHeaderSearchInputValues(activeSearchInput);
      }
    }
    var urlParams = instance.getQueryParams();
    var queryKey = instance.getSearchQueryParam();
    if (!urlParams || !urlParams[queryKey]) {
      instance.getResults(searchTerms);
    }
    if (window.unbxdNormalizeSearchInput && activeSearchInput) {
      window.unbxdNormalizeSearchInput(activeSearchInput);
    }
  }

function isUnbxdSearchProductOutOfStock(product) {
    if (!product) return false;
    if (product.availability === 'false' || product.availability === false) return true;
    if (product.unbxd_availability === 'false') return true;
    if (Array.isArray(product.variants) && product.variants.length > 0) {
        return product.variants.every(function (variant) {
            return variant.availability === 'false' || variant.availability === false;
        });
    }
    return false;
}

function syncAvailabilitySortFilter(instance) {
    if (!instance) return;
    var isAvailabilitySort = instance.state && instance.state.selectedSort === AVAILABILITY_SORT;
    if (isAvailabilitySort) {
        instance.options.defaultFilters = { availability: 'true' };
        instance.__unbxdAvailabilitySortActive = true;
    } else if (instance.__unbxdAvailabilitySortActive) {
        instance.options.defaultFilters = {};
        instance.__unbxdAvailabilitySortActive = false;
    }
}

function patchUnbxdAvailabilitySort(instance) {
    if (!instance || instance.__unbxdAvailabilitySortPatched) return;
    instance.__unbxdAvailabilitySortPatched = true;
    var originalGetResults = instance.getResults.bind(instance);
    instance.getResults = function () {
        syncAvailabilitySortFilter(instance);
        return originalGetResults.apply(instance, arguments);
    };
}

function patchUnbxdProductImpressionDedup(instance) {
    if (!instance || instance.__unbxdImpressionDedupPatched) return;
    instance.__unbxdImpressionDedupPatched = true;
    if (typeof instance.trackImpression !== 'function') return;

    var originalTrackImpression = instance.trackImpression.bind(instance);

    instance.trackImpression = function () {
        var products = (instance.state && instance.state.products) || [];
        if (!products.length) return;

        var query = instance.state && instance.state.userInput
            ? String(instance.state.userInput).trim()
            : '';
        if (!query && typeof instance.getSearchQuery === 'function') {
            query = String(instance.getSearchQuery() || '').trim();
        }

        var requestId = (instance.state && instance.state.requestId) || '';
        var startPage = (instance.state && instance.state.startPageNo) || 0;
        var pids = products.map(function (product) {
            return String(product.uniqueId || product.sku || '');
        }).join(',');

        var signature = [query, requestId, String(startPage), pids].join('|');
        if (signature === instance.__unbxdLastImpressionSignature) {
            if (instance.options && instance.options.debugMode) {
                console.log('[Unbxd] Skipped duplicate product impression', {
                    query: query,
                    requestId: requestId
                });
            }
            return;
        }
        instance.__unbxdLastImpressionSignature = signature;

        var productType = instance.options.productType;
        var payload = { pids_list: [] };

        products.forEach(function (product) {
            payload.pids_list.push(product.uniqueId || product.sku);
        });

        function sendImpressionTrack() {
            if (window.Unbxd && typeof window.Unbxd.addProductsImpression === 'function') {
                if (productType === 'SEARCH') {
                    payload.query = query;
                    window.Unbxd.addProductsImpression(payload);
                    if (instance.options && instance.options.debugMode) {
                        console.log('[Unbxd] search_impression (PRODUCT_IMPRESSIONS)', payload);
                    }
                    return;
                }

                if (productType === 'CATEGORY' || productType === 'BROWSE') {
                    if (window.UnbxdAnalyticsConf) {
                        payload.page = window.UnbxdAnalyticsConf.page || '';
                        payload.page_type = window.UnbxdAnalyticsConf.page_type || '';
                    }
                    window.Unbxd.addProductsImpression(payload);
                }
                return;
            }

            if (window.Unbxd && typeof window.Unbxd.track === 'function') {
                if (productType === 'SEARCH') {
                    payload.query = query;
                    window.Unbxd.track('search_impression', payload);
                } else if (productType === 'CATEGORY' || productType === 'BROWSE') {
                    if (window.UnbxdAnalyticsConf) {
                        payload.page = window.UnbxdAnalyticsConf.page || '';
                        payload.page_type = window.UnbxdAnalyticsConf.page_type || '';
                    }
                    window.Unbxd.track('browse_impression', payload);
                }
                return;
            }

            originalTrackImpression();
        }

        if (window.whenUnbxdTrackReady) {
            window.whenUnbxdTrackReady(sendImpressionTrack);
        } else {
            sendImpressionTrack();
        }
    };
}

function patchUnbxdSearchProductClickDedup(instance) {
    if (!instance || instance.__unbxdProductClickPatched) return;
    instance.__unbxdProductClickPatched = true;

    if (typeof instance.setPageNoParam === 'function' && !instance.__setPageNoParamPatched) {
        instance.__setPageNoParamPatched = true;
        var originalSetPageNoParam = instance.setPageNoParam.bind(instance);
        instance.setPageNoParam = function (pageNo) {
            var pageNoConfig = instance.options && instance.options.url && instance.options.url.pageNoParam;
            if (!pageNoConfig || !pageNoConfig.addToUrl) {
                return originalSetPageNoParam(pageNo);
            }

            try {
                var params = instance.readQueryParamsFromUrl(
                    instance.options.hashMode ? location.hash.slice(1) : location.search
                );
                var usePageNo = pageNoConfig.usePageNo;
                var paramKey = pageNoConfig.algo === 'KEY_VALUE_REPLACER' ? pageNoConfig.keyReplacer: (usePageNo ? 'page' : 'start');
                params[paramKey] = [pageNo];
                var nextUrl = instance.urlSearchParamsToStr(params);
                if (nextUrl === -1 || nextUrl == null || nextUrl === '' || String(nextUrl) === '-1') {
                    return;
                }
            } catch (err) {
                return;
            }

            return originalSetPageNoParam(pageNo);
        };
    }

    if (typeof instance.setRoutingStrategies === 'function' && !instance.__setRoutingStrategiesPatched) {
        instance.__setRoutingStrategiesPatched = true;
        var originalSetRoutingStrategies = instance.setRoutingStrategies.bind(instance);
        instance.setRoutingStrategies = function (url) {
            if (url === -1 || url == null || url === '' || String(url) === '-1') {
                return;
            }
            return originalSetRoutingStrategies(url);
        };
    }

    if (typeof instance.onProductItemClick !== 'function') return;

    var originalOnProductItemClick = instance.onProductItemClick.bind(instance);
    instance.onProductItemClick = function (evt) {
        var target = evt && evt.target;
        if (window.isUnbxdQuickBuyClickTarget && window.isUnbxdQuickBuyClickTarget(target)) {
            return;
        }

        var productLink = target && target.closest ? target.closest('a[href]') : null;
        if (productLink) {
            var href = productLink.getAttribute('href') || '';
            if (href && href !== '#' && href.indexOf('javascript:') !== 0) {
                var productCol = productLink.closest('.UNX-product-col, .product-item');
                var product = null;
                if (productCol && productCol.dataset && productCol.dataset.id && typeof instance.getProductByPropValue === 'function') {
                    var attrMap = (instance.options.products && instance.options.products.attributesMap) || {};
                    product = instance.getProductByPropValue(attrMap.unxId || 'uniqueId', productCol.dataset.id);
                }
                if (product && productCol && productCol.dataset.prank) {
                    product.prank = productCol.dataset.prank;
                }
                if (product && instance.options.products && typeof instance.options.products.onProductClick === 'function') {
                    instance.options.products.onProductClick(product, evt);
                }
                if (product && typeof instance.getCallbackActions === 'function') {
                    instance.getCallbackActions(product, 'click');
                }
                return;
            }
        }

        return originalOnProductItemClick(evt);
    };
}

function patchUnbxdSortUrlSync(instance) {
    if (!instance || instance.__unbxdSortUrlPatched) return;
    instance.__unbxdSortUrlPatched = true;
    if (typeof instance.applySort !== 'function') return;
    var originalApplySort = instance.applySort.bind(instance);
    instance.applySort = function (sortVal) {
        instance.setSort(sortVal);
        syncAvailabilitySortFilter(instance);
        instance.setPageStart(0);
        try {
            var productType = instance.getProductType().toLowerCase();
            var webUrl = instance.getNewUrlState(false);
            var queryString = webUrl.split(productType + '?')[1];
            if (queryString && typeof instance.setRoutingStrategies === 'function') {
                var nextUrl = instance.getUrlStr('?' + queryString);
                if (nextUrl !== -1 && nextUrl != null && nextUrl !== '') {
                    instance.setRoutingStrategies(nextUrl);
                }
            }
        } catch (err) {}
        return instance.getResults();
    };
}

function syncSearchResultsChromeVisibility(instance) {
    var container = document.querySelector('.UNX-results-container');
    if (!container) return;

    var isSearchPage = instance
        && instance.options
        && instance.options.productType === 'SEARCH';
    if (!isSearchPage) {
        container.classList.remove('UNX-search-no-results');
        document.body.classList.remove('unbxd-search-no-results');
        return;
    }

    var hasProducts = instance.state
        && Array.isArray(instance.state.products)
        && instance.state.products.length > 0;

    container.classList.toggle('UNX-search-no-results', !hasProducts);
    document.body.classList.toggle('unbxd-search-no-results', !hasProducts);
}

function clearUnbxdSearchNoResultsUi(instance) {
    var noResultEl = document.getElementById('noResultWrapper');
    if (noResultEl) {
        noResultEl.innerHTML = '';
        noResultEl.classList.remove('UNX-no-results-wrap');
    }
    var resultsEl = document.getElementById('searchResultsWrapper');
    if (resultsEl) resultsEl.classList.remove('UNX-no-results-wrap');
    if (instance && instance.viewState) instance.viewState.noResultLoaded = false;
    syncSearchResultsChromeVisibility(instance);
}

function createUnbxdSearchCallback() {
  return function (instance, type, data) {
    if (type === 'AFTER_API_CALL' && instance && instance.state) {
        if (instance.state.selectedSort === AVAILABILITY_SORT) {
            if (Array.isArray(instance.state.products)) {
                instance.state.products = instance.state.products.filter(function (product) {
                    return !isUnbxdSearchProductOutOfStock(product);
                });
            }
        }

        if (Array.isArray(instance.state.products) && instance.state.products.length > 0) {
            clearUnbxdSearchNoResultsUi(instance);
        } else {
            syncSearchResultsChromeVisibility(instance);
        }

        if (window.trackUnbxdSearchPageAnalytics) {
            window.trackUnbxdSearchPageAnalytics(instance);
        }

        if (window.onUnbxdAfterApiCallFacetsTrack) {
            window.onUnbxdAfterApiCallFacetsTrack(instance);
        }
    }

    if (type === 'AFTER_RENDER' && instance && instance.state
        && Array.isArray(instance.state.products) && instance.state.products.length > 0) {
        if (window.renderUnbxdKlaviyoReviews) {
            window.renderUnbxdKlaviyoReviews();
        }
    }
  };
}


  function initUnbxdSearchPage() {
    if (typeof UnbxdSearch === 'undefined') return;
    var config = getUnbxdSearchPageConfig();

    window.unbxdSearch = new UnbxdSearch(Object.assign({
            siteKey: config.siteKey || '',
            apiKey: config.apiKey || '',
            searchBoxEl: window.getActiveHeaderSearchInput
                ? window.getActiveHeaderSearchInput()
                : document.getElementById("Search-In-Modal"),
            searchTrigger: "click",
            searchButtonEl: window.getActiveHeaderSearchButton
                ? window.getActiveHeaderSearchButton()
                : document.getElementById("Search-In-Modal-button"),
            unbxdAnalytics: true,
            extraParams: {
                version: "V2",
                uid: function () {
                    return window.getUnbxdUserId ? window.getUnbxdUserId() : '';
                }
            },
            setCategoryId: function (param, self) {
            },
            products: { 
                el: document.getElementById("searchResultsWrapper"),
                productType: "SEARCH",
                productAttributes: ["availability","title","descriptionHtml","imageUrl","images","price","handle","meta_reviews_count","meta_reviews_average","meta_product","templateSuffix","variants","variantId","v_compareAtPrice","v_availableForSale","meta_pre_tag","meta_badge","meta_option_obj","productUrl","v_imageUrl","category"],
                onProductClick: function (product, e) {
                    localStorage.setItem('unx_product_clicked', product.uniqueId);
                },
                template: renderSearchProductTemplate,
            },
            spellCheck: {
                enabled: true,
                el: document.getElementById("didYouMeanWrapper")
            },
            noResults: {
                el: document.getElementById("noResultWrapper")
            },
            selectedFacets: {
                el: document.getElementById("selectedFacetWrapper")
            },
            facet: {
                facetsEl: document.getElementById("facetsWrapper"),
                selectedFacetsEl: document.getElementById("selectedFacetWrapper"),
                defaultOpen: "FIRST",
                enableViewMore: true,
                viewMoreLimit: 10,
                applyMultipleFilters: false,
            },
            oldfacet: {
                isCollapsible: true,
                defaultOpen: "NONE",
                viewMoreLimit: 2,
                enableViewMore: true,
                facetsEl: document.getElementById("facetsWrapper"),
                selectedFacetsEl: document.getElementById("selectedFacetWrapper"),
                selectedFacetClass: "UNX-selected-facet-btn",
                facetTemplate: function (facetInfo, facets, isExpanded, facetSearchTxt, facet) {
                    const urlSearchParams = new URLSearchParams(window.location.search);
                    const params = Object.fromEntries(urlSearchParams.entries());
                    var name = facetInfo.displayName;
                    var filterField = facetInfo.filterField;
                    var isSelected = (facetInfo.isSelected) ? 'is-expanded' : '';
                    var searchStr = window.location.search || '';
                    var isSelected = searchStr.includes(facetInfo.facetName) ? 'is-expanded' : '';

                    return [ `<div id="${facetInfo.facetName}" class="facets__filters facets__filters--size js-filter-expand UNX_facet_open ${isSelected}">
                            <span aria-label="Filter: ${filterField}" role="text" class="facets__filters-label">${name}</span>
                            <ul data-search-facet-container="" class="facets__filters-values facets__filters-values--size list-reset js-filter-values UNX_facet_open ${isSelected}">
                            ${facets}
                            </ul>
                            </div>                 
                            `].join('');
                },
                facetItemTemplate: function (facet, value, facetSearchTxt) {
                    const {
                        facetName,
                        isSelected,
                        multiLevelFacetSelectorClass,
                        displayName
                    } = facet;
                    const {
                        name,
                        count,
                        dataId
                    } = value;
                    let {
                        facetClass,
                        selectedFacetClass
                    } = this.options.facet;
                    const {
                        UNX_uFilter
                    } = this.testIds;

                    let action = "changeFacet";
                    let selectedFacet = 'disable';
                    let liCss = '';
                    let hightlighted = '';
                    if (isSelected) {
                        selectedFacet = 'checked';
                        hightlighted = 'highlight';
                        facetClass += ` ${selectedFacetClass} `
                        action = "deleteFacetValue";
                        liCss = (isSelected) ? 'selected' : '';
                    }
                    return [ `<li class="facets__item facets__item--comfort level js-filter-item js-filter-item-${displayName} count-${count} ${liCss} ${facetName}" data-search-facet-value="${dataId}">
                        <label data-search-facet-label="${name}" data-id="${dataId}" class="facet-checkbox facet-checkbox-${displayName} UNX-change-facet ${facetClass} " data-facet-action="${action}" data-test-id="${UNX_uFilter}" data-facet-name="${facetName}" data-handler-init="true">
                        <input data-search-facet-input="" ${selectedFacet} class="js-filter-checkbox UNX-change-facet" type="checkbox" value="${name}" data-facet-action="${action}" data-facet-name="${facetName}" data-id="${dataId}">
                        <span class="${hightlighted}">${name} (${count})</span>
                        </label>
                        </li>`].join('');
                },
                selectedFacetTemplate: function (selections, facet, selectedFacetsConfig) {
                    const {
                        clearAllText,
                        clearFacetsSelectorClass
                    } = facet;
                    const selectedFClass = (this.selectedFacetClass) ? this.selectedFacetClass : selectedFacetsConfig.selectedFacetClass;

                    if (selections.length > 0) {
                        return [ `<div class="collection__active-filters UNX-facets-selections">`,
                            `<h5 class="UNX-selected-facet-header">Selected Filters:</h5>`,
                            `<div class="UNX-selected-facets-inner">${selections}</div>`,
                            `<button type="button" class="${clearFacetsSelectorClass || 'UNX-clear-facet'} UNX-selected-facet-btn" data-facet-action="clearAllFacets">${clearAllText || 'Clear All'}</button>`,
                            `</div>` ].join('');
                    } else {
                        return ``;
                    }
                },
                selectedFacetItemTemplate: function (selectedFacet, selectedFacetItem, facetConfig, selectedFacetsConfig) {
                    const {
                        facetName,
                        facetType
                    } = selectedFacet;
                    const {
                        name,
                        count,
                        dataId
                    } = selectedFacetItem;
                    const {
                        facetClass,
                        selectedFacetClass,
                        removeFacetsSelectorClass
                    } = this.options.facet;
                    const {
                        UNX_uFilter
                    } = this.testIds;
                    let action = "deleteSelectedFacetValue";

                    const css = ` ${facetClass} ${selectedFacetClass} `;

                    return [ `<a data-test-id="${UNX_uFilter}" class="collection__active-filters-btn btn btn--tertiary search-facet-display-name search-facet-remove-only ${css}" data-facet-name-value="metaf_${facetName}" data-facet-action="${action}" 
                            data-facet-name="${facetName}" data-facet-value="${facetName}" data-id="${dataId}" data-handler-init="true">${name}
                            </a>`].join('');
                },
            },
            pagination: {
                // type: 'CLICK_N_SCROLL',
                type: 'FIXED_PAGINATION',
                // type: 'INFINITE_SCROLL',
                el: document.querySelector('.unxPagination'),
                // usePageAndCount: false,
                virtualization: false,
                bufferPages: 1,
                heightDiffToTriggerNextPage: 100,
                infiniteScrollTriggerEl: document.getElementById('searchResultsWrapper'),
                onPaginate: function () {}
            },
            url: {
                hashMode: false,
                allowExternalUrlParams: false,
                seoFriendlyUrl: true,
                orderOfQueryParams: ["QUERY",  "FILTERS", "PAGE_NUMBER" ,"PAGE_SIZE","SORT","VIEW_TYPE"], //defaults.
                queryParamSeparator: "&",
                searchQueryParam: {
                    addToUrl: true,
                    algo: "KEY_VALUE_REPLACER",
                    keyReplacer: "q"
                },
                browseQueryParam: {
                    addToUrl: true,
                    algo: "DEFAULT",
                    // keyReplacer: "pppp"
                },
                pageViewParam: {
                    addToUrl: true,
                    algo: "KEY_VALUE_REPLACER",
                    keyReplacer: "view",
                    valuesReplacer: {
                        "GRID": "GRID",
                        "LIST": "LIST"
                    }
                },
                sortParam: { 
                    addToUrl: true,
                    algo: "KEY_VALUE_REPLACER",
                    keyReplacer: "sortBy",
                    valueReplacer: {
                        "availability desc": "availability",
                        "title asc": "title-asc",
                        "title desc": "title-desc",
                        "price asc": "price-asc",
                        "price desc": "price-desc"
                    }
                },
                pageNoParam: { 
                    addToUrl: true,
                    algo: "DEFAULT",
                    keyReplacer: 'p', 
                    usePageNo: true // uses page no. when turned on.else , index
                },
                pageSizeParam: {
                    addToUrl: true,
                    algo: "DEFAULT",
                    keyReplacer: "count"
                },
                facetsParam: {
                    addToUrl: true,
                    algo: "KEY_VALUE_REPLACER",
                    multiValueSeparator: ",",
                    keyReplacer: {
                        "color_uFilter": "color",
                        "size_uFilter": "size",
                        "gender_uFilter": "gender",
                        "occasion_uFilter": "occasion",
                        "fit_uFilter": "fit",
                        "type_uFilter": "type",
                        "brand_uFilter": "brand"
                    },
                    valueReplacer: {
                        "color_uFilter": {
                            "Multi": "multi",
                            "White": "whitee"
                        },
                        "occasion_uFilter": {
                            "Wear to Work": "Wear-to-work"
                        }
                    },
                    facetsOrderInUrl: ["category-filter", "price", "brand_uFilter", "brand", "gender_uFilter", "color_uFilter"],
                    rangeFacets: ["price"],
                    rangeSeparator: "-"
                }
            },
            breadcrumb: {
                el: document.getElementById("breadcrumpContainer")
            },
            pagesize: {
            enabled: true,
            el: document.getElementById("changeNoOfProducts"),
            pageSize: 24,
            options: [24, 48, 72]
            },
            sort: {
                enabled: true,
                el: document.getElementById("sortWrapper"),
                sortClass: "UNX-sort-item",
                selectedSortClass: "UNX-selected-sort",
                template: function (selectedSort, facetConfig) {
                    var config = facetConfig || this.options.sort || {};
                    var options = config.options || [];
                    var sortClass = config.sortClass || "UNX-sort-item";
                    var selectedClass = config.selectedSortClass || "UNX-selected-sort";
                    var testId = this.testIds.UNX_unbxdSorter || "";
                    var optionsHtml = "";
                    options.forEach(function (opt) {
                        var isSelected = opt.value === selectedSort;
                        optionsHtml += '<option value="' + opt.value + '" class="' + (isSelected ? selectedClass : "") + '"' + (isSelected ? ' selected' : '') + '>' + opt.text + '</option>';
                    });
                    var defaultSelected = !selectedSort ? ' selected' : '';
                    return [
                        '<div class="UNX-sort-block">',
                        '<span class="UNX-sort-header">Sort By</span>',
                        '<label class="UNX-hidden" for="unxSortSelect">Sort By</label>',
                        '<div class="block__short-facets">',
                        '<select data-test-id="' + testId + '" name="unxSortSelect" data-action="changeSort" id="unxSortSelect" class="' + sortClass + '">',
                        '<option value=""' + defaultSelected + '>Best Selling</option>',
                        optionsHtml,
                        '</select></div></div>'
                    ].join('');
                },
                options: [
                    {
                        value: "availability desc",
                        text: "Availability"
                    },
                    {
                        value: "title asc",
                        text: "Alphabetically, A-Z"
                    },
                    {
                        value: "title desc",
                        text: "Alphabetically, Z-A"
                    },
                    {
                        value: "price asc",
                        text: "Price, low to high"
                    },
                    {
                        value: "price desc",
                        text: "Price, high to low"
                    }
                ]
            },
            loader: {
                el: document.getElementById("loaderEl")
            },
            productView: {

                enabled: true,

                el: document.getElementById("productViewTypeContainer"), 

                defaultViewType: "GRID",

                viewTypes: ["GRID", "LIST"], // optional

                viewTypeClass: "UNX-product-view",

                selectedViewTypeClass: "UNX-selected-product-view"

            },
            banner: {
                el: document.getElementById("bannerContainer"),
                count: 1
            },
            swatches: {
                enabled: true,
                attributesMap: {
                    swatchList: "color",
                    swatchImgs: "unbxd_color_mapping",
                    swatchColors: "color"
                }
            },
            filtered: true,
            variants: {
            enabled: true,
            count:100,
            groupBy:'',
            attributes:["title", "v_price", "v_compareAtPrice","variantId","v_imageUrl","v_availableForSale"],
            mapping	: { "v_price": "v_price", "v_compareAtPrice":"v_compareAtPrice", "title": "title","variantId":"variantId", "v_imageUrl":"v_imageUrl", "v_availableForSale":"v_availableForSale"}
            },
            onAction: function (e, ctx) { },
            onEvent: createUnbxdSearchCallback(),
            debugMode: true,
            browseQueryParam: 'p-id'
        }, config.sdkOverrides || {}));
        
    applyUnbxdSearchPatches(window.unbxdSearch);
    bootstrapUnbxdSearchPage(window.unbxdSearch, config.searchTerms);
  }

  document.addEventListener('DOMContentLoaded', initUnbxdSearchPage);
})();
